<!--
 * @Author: v_hllhe
 * @Date: 2022-12-22 11:17:29
 * @LastEditors: v_aydwang
 * @LastEditTime:2023-01-10 17:17:25
 * @Description:
-->
<template>
  <div>
    <div id="bottomScore">
      <div class="lineLeft"></div>
      <div class="lineRight"></div>
      <div class="theory">
        <div class="whiteLine"></div>
        <div class="desc">理论</div>
        <five-star class="fiveStar" :starLevel="theoryScore"></five-star>
        <div class="wrap">
          <div class="bottom">
            <div class="num">{{ passRate || 0 }}%</div>
            <div class="title">平均一次考试通过率</div>
          </div>
        </div>
      </div>
      <div class="safe">
        <div class="whiteLine"></div>
        <div class="desc">稳定</div>
        <five-star class="fiveStar" :starLevel="safeScore"></five-star>
        <div class="wrap">
          <div class="bottom">
            <div class="num">{{ weekRate || 0 }}%</div>
            <div class="title">周环比波动</div>
          </div>
          <div  v-show="chartVisible.length!=0"  ref="echartDom" id="chartId" class="echarts" />
          <div v-show="chartVisible.length===0" class="emptydata">
            <Icon :component="emptyData" class="weekIcon" />
            <p>暂无周环比数据</p>
          </div>
        </div>
      </div>
      <div class="theory" style="margin: 0;">
        <!-- <div class="whiteLine"></div> -->
        <div class="desc">实践</div>
        <five-star class="fiveStar" :starLevel="practiceScore || 0"></five-star>
        <div class="wrap">
          <div class="bottom">
            <div class="num">
              {{ averageRange || 0 }}
              <span>天</span>
            </div>
            <div class="title">平均达标周期</div>
          </div>
        </div>
      </div>
      <div class="circleWrap">
        <circleGif class="circleGif" type="blue" :warning="true"> </circleGif>
        <div class="circleContent">
          <five-star
            class="fiveStar"
            type="large"
            :starLevel="abilityScore"
          ></five-star>
          <div class="title">
            <div>潜力</div>
             <a-tooltip placement="top" overlayClassName="potentialTip">
              <template slot="title">
                <span
                  v-html="tipconfig.potentialTip"
                ></span>
              </template>
              <div class="tips"></div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="theory skill">
        <div class="whiteLine"></div>
        <div class="desc">技能</div>
        <div class="detail" @click="controlModal">
          <span>详情</span>
          <Icon :component="rightArrow" class="icon" />
        </div>
        <five-star class="fiveStar" :starLevel="skillScore"></five-star>
        <div class="wrap">
          <div class="bottom">
            <div class="num">{{ skillSum || 0 }}</div>
            <div class="title">技能数量</div>
          </div>
          <div class="bottom">
            <div class="num">{{ skillExcellent || 0 }}</div>
            <div class="title">优秀技能</div>
          </div>
          <div class="bottom">
            <div class="num">{{ skillBetter || 0 }}</div>
            <div class="title">良好技能</div>
          </div>
          <div class="bottom">
            <div class="num">{{ skillBad || 0 }}</div>
            <div class="title">不合格技能</div>
          </div>
        </div>
      </div>
      <div class="theory active">
        <!-- <div class="whiteLine"></div> -->
        <div class="desc">积极</div>
        <five-star class="fiveStar" :starLevel="activeScore"></five-star>
        <div class="wrap">
          <!-- <div class="bottom">
          <div class="num">{{effectRecall}}</div>
          <div class="title">有效反馈</div>
        </div> -->
          <div class="bottom">
            <div class="num">{{ effectComment || 0 }}</div>
            <div class="title">有效评价</div>
          </div>
          <!-- <div class="bottom">
          <div class="num">{{effectAsk}}</div>
          <div class="title">有效提问</div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import fiveStar from './fiveStar.vue';
import circleGif from '@/components/circleGif';
import { EchartOpt } from './lineChart';
import personalDetails from '../modules/personalDetails.vue';
import echarts from 'echarts';
import Icon from 'ant-design-vue/es/icon';
import rightArrow from '@/assets/rightArrow.svg';
import emptyData from '@/assets/personnel-large/empty.svg';
import {
  getPassRate,
  getPractice,
  getSkill,
  getActive,
  getStable,
} from '@/api/personnelLarge.js';
import { tipconfig } from '../modules/const.js';

export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {
    fiveStar,
    circleGif,
    personalDetails,
    Icon,
  },
  props: {
    uid: {
      type: String,
      default: '',
    },
  },
  data() {
    // 这里存放数据
    return {
      tipconfig,
      rightArrow,
      emptyData,
      // skillVisible: false,
      // 评分信息
      theoryScore: 0, // 理论评分
      passRate: 0, // 平均一次考试通过率
      safeScore: 0, // 稳定评分
      weekRate: 0, // 周环比波动
      practiceScore: 0, // 实践评分
      averageRange: 0, // 平均达标周期
      abilityScore: 0, // 潜力评分
      skillScore: 0, // 技能评分
      skillSum: 0, // 技能数量
      skillExcellent: 0, // 优秀技能
      skillBetter: 0, // 良好技能
      skillBad: 0, // 不合格技能
      activeScore: 0, // 积极评分
      effectRecall: 0, // 有效反馈
      effectComment: 0, // 有效评价
      effectAsk: 0, // 有效提问
      workDetailsList: [], // 作业情况
      messageList: [], // 历史项目信息
      chartVisible: [], // 周环比数据
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    uid() {
      // this.init();
    },
  },
  // 方法集合
  methods: {
    init(uid) {
      const theory = getPassRate({ uid }).then((res) => {
        this.theoryScore = res.stars;
        this.passRate = res.pass_rate != 0 ? (res.pass_rate * 100).toFixed(0) : 0;
      });
      const practice = getPractice({ uid }).then((res) => {
        this.practiceScore = res.stars;
        this.averageRange = res.days_count;
      });
      const skill = getSkill({ uid }).then((res) => {
        this.skillScore = res.stars;
        this.skillSum = res.sum_skill_count;
        this.skillExcellent = res.excellent_skill_count;
        this.skillBetter = res.good_skill_count;
        this.skillBad = res.unqualified_skill_count;
      });
      const active = getActive({ uid }).then((res) => {
        this.activeScore = res.stars;
        this.effectAsk = res.valid_question_count;
        this.effectComment = res.valid_evaluation_count;
      });
      Promise.all([theory, practice, skill, active, this.setEcharts(uid)]).then(() => {
        this.abilityScore = Math.round((this.safeScore
            + this.theoryScore
            + this.practiceScore
            + this.skillScore
            + this.activeScore)
            / 5);
      });
    },
    controlModal() {
      this.$emit('skillOpen', true);
    },
    setEcharts(uid) {
      const axisData = [];
      const seriesData = [];
      this.chartVisible = [];
      this.safeScore = 0;
      this.weekRate = 0;
      getStable({ uid }).then((res) => {
        if (res) {
          this.safeScore = res.stars;
          this.weekRate = res.avg_radio != 0 ? (res.avg_radio * 100).toFixed(2) : 0;
          this.chartVisible = res.week_radio;
          res.week_radio.map((item) => {
            item.value = item.value != 0 ? (item.value * 100).toFixed(2) : 0;
            axisData.push(item.statis_day);
            seriesData.push(item.value);
          });
          if (res.week_radio.length != 0) {
            if (!this.echartsIns) {
              this.$nextTick(() => {
                const { echartDom } = this.$refs;
                this.echartsIns = echarts.init(echartDom);
              });
            }
            const opts = EchartOpt();
            opts.xAxis.data = axisData;
            opts.series[0].data = seriesData;
            if (axisData.length === 1) {
              opts.series[0].label.show = true;
              opts.series[0].showSymbol = true;
              opts.series[0].itemStyle.opacity = 1;
              opts.tooltip.textStyle.color = 'rgba(0,0,0,0)';
            } else {
              opts.series[0].label.show = false;
              opts.series[0].showSymbol = false;
              opts.series[0].itemStyle.opacity = 0;
              opts.tooltip.textStyle.color = '#fff';
            }
            this.$nextTick(() => {
              this.echartsIns.setOption(opts);
            });
          }
        }
      });
    },
    resize() {
      this.echartsIns && this.echartsIns.resize();
    },

  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener('resize', this.resize);
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/convert-viewport";
.close-x {
  width: vw(32);
  height: vw(32);
  background: url("~@/assets/personnel-large/close.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: vh(8);
  right: vw(10);
  cursor: pointer;
}
#bottomScore {
  display: flex;
  background: url("~@/assets/bottomBackground.png");
  background-size: 100% 100%;
  width: vw(1883);
  padding: vw(5) 0;
  .circleWrap {
    // animation: myfirst 2s infinite ease-in-out;
  }
  @keyframes myfirst {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  .circleWrap,
  .circleGif,
  .circleContent {
    width: vw(220);
    height: vw(220);
    position: absolute;
    left: 50%;
    margin-left: vw(-110);
    overflow: hidden;
  }
  .circleContent {
    text-align: center;
    .fiveStar {
      margin-top: vw(76);
    }
    .title {
      margin-top: vh(14);
      font-family: TencentSansW7;
      font-size: vw(24);
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: vh(32);
      display: flex;
      justify-content: center;
    }
    .tips {
      width: vw(18);
      height: vw(18);
      background: url("~@/assets/whiteTips.png");
      background-size: 100% 100%;
      margin-top: vh(10);
      cursor: pointer;
    }
  }
  .theory {
    text-align: center;
    position: relative;
    width: vw(223.5);
    height: vh(260.5);
    margin-left: vw(10);
    overflow: hidden;
    .whiteLine {
      width: vw(1);
      height: vh(172);
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background-image: linear-gradient(
        to top,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
      );
    }
    .desc {
      font-family: TencentSansW7;
      font-size: vw(20);
      color: #ffffff;
      letter-spacing: 0;
      line-height: vh(26);
      margin-top: vh(42.5);
    }
    .fiveStar {
      margin-top: vh(13.42);
    }
    .wrap {
      width: 100%;
      display: flex;
      // justify-content: center;
      justify-content: space-around;
    }
    .bottom {
      margin-top: vh(30);
      height: vh(65);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .num {
        font-family: TCloudNumber-Regular;
        font-weight: 400;
        font-size: vw(32);
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: vh(28);
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: vw(16);
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: vh(24);
        }
      }
      .title {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: vw(14);
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: vh(28);
      }
    }
  }
  .safe {
    text-align: center;
    position: relative;
    width: vw(362.2);
    height: vh(260.5);
    margin-left: vw(10);
    overflow: hidden;
    .whiteLine {
      width: vw(1);
      height: vh(172);
      background-image: linear-gradient(
        to top,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
      );
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .desc {
      font-family: TencentSansW7;
      font-size: vw(20);
      color: #ffffff;
      letter-spacing: 0;
      line-height: vh(26);
      margin-top: vh(42.5);
    }
    .fiveStar {
      margin-top: vh(13.42);
    }
    .wrap {
      margin-top: vh(24);
      height: vh(71);
      display: flex;
      justify-content: space-around;
      // background: red;
      .echarts,.emptydata {
        margin-top: vh(4);
        width: vw(180.2);
        height: 100%;
        // border: 1px solid white;
      }
        .emptydata {
          margin-top:vh(12);
          color:#fff;
          font-size: vw(14);
          font-family: PingFangSC;
          opacity: 0.6;
        .weekIcon{
          font-size: vh(30);
          vertical-align: middle;
          line-height: vh(26);
        }
      }
    }
    .bottom {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .num {
        margin-top: vh(6);
        font-family: TCloudNumber-Regular;
        font-weight: 400;
        font-size: vw(32);
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: vh(28);
      }
      .title {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: vw(14);
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: vh(28);
      }
    }
  }

  .skill {
    // width: vw(428);
    width: vw(528);
    margin-left: vw(260);
    .detail {
      cursor: pointer;
      position: absolute;
      right: vw(35.5);
      top: vh(80);
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: vw(14);
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: vh(28);
      .icon {
        font-size: vw(18);
        vertical-align: middle;
        line-height: vh(26);
      }
    }
  }
  .active {
    // width: vw(311.5);
    width: vw(230);
    // background: red;
    // opacity: 0.3;
  }
}
.lineLeft,
.lineRight {
  position: absolute;
  top: vh(8);
  width: vw(100);
  height: vh(2);
  border-radius: 2px;
  box-shadow: 0 0 10px white;
}
.lineLeft {
  left: vw(200);
  animation: glowLeft 3s linear infinite;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 1)
  );
}
.lineRight {
  right: vw(200);
  animation: glowRight 3s linear infinite;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.3)
  );
}

@keyframes glowLeft {
  0% {
    width: vw(60);
    transform: translate(0px, 0px);
  }
  50% {
    width: vw(200);
    transform: translate(vw(200), 0px);
  }
  100% {
    width: 0px;
    transform: translate(vw(540), 0px);
  }
}
@keyframes glowRight {
  0% {
    width: vw(60);
    transform: translate(0px, 0px);
  }
  50% {
    width: vw(150);
    transform: translate(vw(-150), 0px);
  }
  100% {
    width: 0px;
    transform: translate(vw(-300), 0px);
  }
}

</style>
<style >
.potentialTip{
  overflow-y: auto;
  min-width: 800px;
  max-height: 400px;
  border-radius: 8px;
}
.potentialTip::-webkit-scrollbar {
  display: none;
}
.potentialTip>.ant-tooltip-content>.ant-tooltip-inner{
    background:rgba(255, 255, 255, 0.8) !important;
    color:#56688A;
    padding: 20px 10px 10px 20px;
}
.potentialTip>.ant-tooltip-content>.ant-tooltip-arrow::before{
    background:rgba(255, 255, 255, 0) !important;
}

</style>
